export const en = {
    'event-error-title': 'An event is not available',
    'event-error-description': 'An event with such event_id does not exist or you are not in the list of participants'
};
